/**
 * RTWO Indexer Engine — Validation Service
 */

import { INDEXER_SERVICE_IDS } from '../domain-models';
import type { IndexedBlockId, IndexedTransactionId } from '../domain-models';
import type { IIndexValidationService, ValidationResult } from '../service-interfaces';
import type {
  ProtocolAdapterRegistry,
  LedgerAdapterRegistry,
} from '../registry/adapter-registries';
import { BaseIndexerService, type IndexerServiceContext } from './base-indexer-service';

export class IndexValidationService extends BaseIndexerService implements IIndexValidationService {
  readonly serviceId = INDEXER_SERVICE_IDS.VALIDATION;
  readonly serviceName = 'Index Validation Service';
  readonly description =
    'Validates indexed data against RTWO schema. Waiting for real blockchain data.';
  readonly integrations = ['Core Engine', 'Block Indexing Service', 'Transaction Indexing Service'];
  readonly requiresRPCSource = true;
  readonly requiresIndexStorage = false;

  constructor(
    context: IndexerServiceContext,
    private readonly protocolRegistry: ProtocolAdapterRegistry,
    private readonly ledgerRegistry: LedgerAdapterRegistry
  ) {
    super(context);
  }

  async initialize(): Promise<void> {
    this.status = 'structure_ready';
  }

  async validateIndexedBlock(_indexedBlockId: IndexedBlockId): Promise<ValidationResult> {
    return {
      valid: false,
      errors: ['Waiting for Real Blockchain Data — No blocks to validate.'],
      isPlaceholder: true,
      source: 'Indexer Engine — Waiting for Real Blockchain Data',
    };
  }

  async validateIndexedTransaction(
    _indexedTransactionId: IndexedTransactionId
  ): Promise<ValidationResult> {
    return {
      valid: false,
      errors: ['Waiting for Real Blockchain Data — No transactions to validate.'],
      isPlaceholder: true,
      source: 'Indexer Engine — Waiting for Real Blockchain Data',
    };
  }

  getValidationPassRate(): null {
    if (!this.protocolRegistry.isConfigured() && !this.ledgerRegistry.isConfigured()) {
      return null;
    }

    return null;
  }
}
